import React from "react";
import TeaserList from "../TeaserList";
export function BlockBlogListing(props) {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, props.title && /*#__PURE__*/ React.createElement("h3", {
        className: "container-content-wrapper text-turquoise-500 w-auto block text-center"
    }, props.title), /*#__PURE__*/ React.createElement(TeaserList, {
        teaserListItems: props.posts
    }));
}
